import MenuJp from "@/utils/pageParts/top/jp/Menu";
import HeaderJp from "@/utils/pageParts/top/jp/Header";
import FooterJp from "@/utils/pageParts/top/jp/Footer";
import LeftMenuJp from "@/utils/pageParts/top/jp/LeftMenu";
import RightMenuJp from "@/utils/pageParts/top/jp/RightMenu";
import { useEffect, useState } from "react";
import Head from "next/head";
import styles from '@/css/index.module.css';
import { company } from "@/utils/version";

export default function Privacy(){
    const [menuStatus, setMenuStatus] = useState(false);
    useEffect(() => {
        if(typeof document !== "undefined"){
            document.body.style.overflow = menuStatus ? "hidden" : "";
            return () => {
                document.body.style.overflow = "";
            };
        }
    }, [menuStatus]);
    const handleClick = () => {
        setMenuStatus(prev => !prev);
    };
    return(
        <>
            <Head>
                <title>あさクラWikiプライバシーポリシー</title>
            </Head>
            <MenuJp handleClick={handleClick} menuStatus={menuStatus}/>
            <div className={styles.contentsWrapper} style={{ fontFamily: 'Noto Sans Japanese,sans-serif' }}>
                <HeaderJp handleClick={handleClick}/>
                <div className={styles.contents}>
                    <LeftMenuJp URL="/policies" rupages="false"/>
                    <main style={{ padding: '2rem', flex: 1 }}>
                        <header className="pEntry__header">
                            <h1>プライバシーポリシー</h1>
                        </header>
                        <p>株式会社<ruby>{company}<rt>じゅうさんにんすたじお</rt></ruby>（以下「当社」といいます。）は、当社の提供するサービス（以下「本サービス」といいます。）における、ユーザーについての個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</p>
                        <div className="p-entry__content">
                            <h2>第1条 個人情報の定義</h2>
                            <p>本ポリシーにおいて、「個人情報」とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの(他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。)を意味するものとします。</p>
                            <h2>第2条 収集する利用者情報及び収集方法</h2>
                            <p>本ポリシーにおいて、「利用者情報」とは、ユーザーの識別に係る情報、通信サービス上の行動履歴、その他ユーザーのスマートフォン、PC等の端末においてユーザーまたはユーザーの端末に関連して生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味するものとします。 本サービスにおいて当社が収集する利用者情報は、その収集方法に応じて、以下のようなものとなります。</p>
                            <ol>
                                <li>
                                    ユーザーからご提供いただく情報
                                    <p>当社は、本サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。</p>
                                    <ul>
                                        <li>メールアドレス</li>
                                        <li>その他当社が定める入力フォームにユーザーが入力する情報</li>
                                    </ul>
                                </li>
                                <li>
                                    ユーザーが本サービスの利用において、他のサービスと連携を許可することにより、当該他のサービスからご提供いただく情報
                                    <p>ユーザーが、本サービスを利用するにあたり、ソーシャルネットワークサービス等の外部サービスとの連携を許可した場合には、その許可の際にご同意いただいた内容に基づき、以下の情報を当該外部サービスから収集します。</p>
                                    <ul>
                                        <li>当該外部サービスでユーザーが利用するID</li>
                                        <li>その他当該外部サービスのプライバシー設定によりユーザーが連携先に開示を認めた情報</li>
                                    </ul>
                                </li>
                                <li>
                                    ユーザーが本サービスを利用するにあたって、当社が収集する情報
                                    <p>当社は、本サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。</p>
                                    <ul>
                                        <li>端末情報</li>
                                        <li>ログ情報</li>
                                        <li>Cookie及び匿名ID</li>
                                        <li>位置情報</li>
                                    </ul>
                                </li>
                            </ol>
                            <h2>第3条 利用目的</h2>
                            <ol>
                                <li>利用者情報は、第3条2項に定めるとおり本サービスの提供のために利用されるほか、第3条3項に定めるとおり、その他の目的にも利用される場合があります。</li>
                                <li>
                                    サービスのサービス提供にかかわる利用者情報の具体的な利用目的は以下のとおりです。
                                    <ol>
                                        <li>本サービスに関する登録の受付、本人確認、維持、保護及び改善のため</li>
                                        <li>本サービスに関するご案内、お問い合せ等への対応のため</li>
                                        <li>本サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため</li>
                                        <li>本サービスに関する規約等の変更などを通知するため</li>
                                        <li>上記の利用目的に付随する利用目的のため</li>
                                    </ol>
                                </li>
                                <li>
                                    上記第3条2項以外の利用目的は以下のとおりです。
                                    <ol>
                                        <li>当社のサービスに関連して、個人を識別できない形式に加工した統計データを作成するため</li>
                                    </ol>
                                </li>
                            </ol>
                            <h2>第4条 外部送信、第三者提供、情報収集モジュールの有無</h2>
                            <p>利用者情報を利用したターゲティング広告の配信のため、本サービスには以下の情報収集モジュールが組み込まれています。これに伴い、以下のとおり情報収集モジュール提供者への利用者情報の提供を行います。</p>
                            <ol>
                                <li>情報収集モジュールの名称 Google Analytics</li>
                                <li>情報収集モジュールの提供者 Google LLC.</li>
                                <li>提供される利用者情報の項目 行動履歴情報</li>
                                <li>提供の手段・方法 www.google.com/analytics</li>
                                <li>上記提供者における利用目的 利用者情報を自動取得するため</li>
                                <li>上記提供者における第三者提供の有無 以下に記載されているプライバシーポリシーのリンクによりご確認ください</li>
                                <li>上記提供者のプライバシーポリシーのURL <a href="https://www.google.com/analytics/terms/jp.html">https://www.google.com/analytics/terms/jp.html</a></li>
                            </ol>
                            <p>本サービスでは株式会社{company} の提供しているサービスを利用して、本サービスや他のサービスへの過去のアクセス情報に基づく広告配信を行っています。</p>
                            <h2>第5条 第三者提供</h2>
                            <p>当社は、利用者情報のうち、個人情報については、<a href="/policies">あさクラWiki利用規約</a>その他の14nin系列利用規約に基づき開示が認められる場合を除くほか、あらかじめユーザーの同意を得ないで、第三者に提供しません。但し、次に掲げる場合はこの限りではありません。</p>
                            <p>注意 第三者や法執行機関などのからの法令に基づく開示要求はどんな理由があろうと<strong>拒否</strong>させていただきます。</p>
                            <ol>
                                <li>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>
                                <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
                                <li>第4項の定めに従って、情報収集モジュール提供者へ個人情報が提供される場合</li>
                                <li>{company}もしくは{company}の関係者またはその委託を受けた者が14nin系列利用規約の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることや国の機関もしくは地方公共団体の妨害的行動によって当該事務の遂行に支障を及ぼすおそれがある場合</li>
                                <li>その他、<a href="/policies">あさクラWiki利用規約</a>その他の14nin系列利用規約で認められる場合</li>
                            </ol>
                            <h2>第6条 個人情報の開示</h2>
                            <p>当社は、ユーザーから、14nin系列利用規約の定めのみに基づき個人情報の開示を求められたときは、</p>
                            <p>ユーザーご本人からのご請求であることを確認の上で、ユーザーに対し、遅滞なく開示を行います</p>
                            <p>（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、<a href="/policies">あさクラWiki利用規約</a>その他の14nin系列利用規約により、当社が開示の義務を負わない場合は、この限りではありません。</p>
                            <p>なお、個人情報の開示につきましては、手数料（1件あたり4120円(あさクラメンバーは1件あたり400円)）を頂戴しておりますので、あらかじめ御了承ください。</p>
                            <p>個人情報保護法の定めのみに基づき個人情報の開示を求められたときは拒否致します。</p>
                            <h2>第7条 個人情報の訂正及び利用停止等</h2>
                            <ol>
                                <li>当社は、ユーザーから、⑴個人情報が真実でないという理由によって<a href="/policies">あさクラWiki利用規約</a>の定めに基づきその内容の訂正を求められた場合、及び⑵あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、<a href="/policies">あさクラWiki利用規約</a>の定めに基づきその利用の停止を求められた場合には、ユーザーご本人からのご請求であることを確認の上で遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正または利用停止を行い、その旨をユーザーに通知します。なお、合理的な理由に基づいて訂正または利用停止を行わない旨の決定をしたときは、ユーザーに対しその旨を通知いたします。</li>
                                <li>当社は、ユーザーから、ユーザーの個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、ユーザーご本人からのご請求であることを確認の上で、個人情報の消去を行い、その旨をユーザーに通知します。</li>
                                <li><a href="/policies">あさクラWiki利用規約</a>その他の14nin系列利用規約により、当社が訂正等または利用停止等の義務を負わない場合は、前2項の規定は適用されません。</li>
                            </ol>
                            <h2>第8条 Cookie、ログ情報</h2>
                            <p>当社では、本サービスの利便性をあげるために、Cookie、アクセス解析、統計データなどを保存、利用します。また当社ではCookieやJavaScriptなどの技術を利用し、ユーザーの行動履歴を取得することがあります。なお、これらには個人情報は含まれません。</p>
                            <h2>第9条 免責</h2>
                            <p>以下の場合は、第三者による個人情報の取得に関し、当社は何らの責任を負いません。</p>
                            <ol>
                                <li>ユーザー自らが当サービス上の機能または別の手段を用いて第三者に個人情報を明らかにする場合</li>
                                <li>ユーザーが本サービス上に入力した情報、活動情報等により、期せずして個人が特定できてしまった場合</li>
                                <li>第三者が当サイト外で個人情報その他の利用者情報を取得した場合</li>
                                <li>ユーザーご本人以外がユーザー個人を識別できる情報(ID・パスワード等)を入手した場合</li>
                            </ol>
                            <h2>第10条 お問い合わせ</h2>
                            <p>本ポリシーならびに利用者情報に関するお問い合わせは <a href="https://sakitibi-com9.webnode.jp/page/3">お問い合わせページ</a> よりお願いいたします。</p>
                            <h2>第11条 プライバシーポリシーの変更手続</h2>
                            <p>当社は、利用者情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本ポリシーを変更することがあります。変更した場合には、メール等の方法でユーザーに通知いたします。但し、法令上ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法でユーザーの同意を得るものとします。</p>
                        </div>
                    </main>
                    <RightMenuJp/>
                </div>
                <FooterJp/>
            </div>
        </>
    )
}